import React, { useEffect, useState } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import UserService from "services/UserService";
import DataTable from "examples/Tables/DataTable";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  Autocomplete,
  Switch,
  FormControlLabel,
} from "@mui/material";
import Notifications from "layouts/notifications";

export default function Data() {
  const [users, setUsers] = useState([]);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [openMessage, setOpenMessage] = useState({ isOpen: false, type: '', message: '' });
  const [userIdToDelete, setUserIdToDelete] = useState(null);
  const [editUser, setEditUser] = useState({ Id: '', Name: '', Email: '', Main: false, SupplierId: '', RoleId: '' });
  const [addUser, setAddUser] = useState({ Name: '', Email: '', Main: false, SupplierId: 1, RoleId: '' });
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    UserService.getUsers()
      .then((response) => {
        setUsers(response.data.data);
      })
      .catch((error) => {
        console.error("There was an error fetching the users!", error);
      });
  }, [refresh]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenMessage({ isOpen: false, type: '', message: '' });
  };

  const handleDeleteClick = (userId) => {
    setUserIdToDelete(userId);
    setOpenDeleteDialog(true);
  };

  const handleEditClick = (user) => {
    setEditUser({ Id: user.Id, Name: user.Name, Email: user.Email, Main: user.Main, SupplierId: user.SupplierId, RoleId: user.Role.Id });
    setOpenEditDialog(true);
  };

  const handleEditConfirm = () => {
    const Id = editUser.Id || false
    if (Id) {
      delete editUser.Id; //Id não pode ser alterado.

      UserService.editUser(Id, editUser, false)
        .then(() => {
          setOpenEditDialog(false);
          setEditUser({ Id: '', Name: '', Email: '', Main: false, SupplierId: '', RoleId: '' });
          setOpenMessage({ isOpen: true, type: 'success', message: 'Dados editados!' });
          setRefresh(prev => !prev);
        })
        .catch((error) => {
          console.error("There was an error updating the user!", error);
          setOpenEditDialog(false);
          setOpenMessage({ isOpen: true, type: 'error', message: 'Erro ao editar dados!' });
          setEditUser({ Id: '', Name: '', Email: '', Main: false, SupplierId: '', RoleId: '' });
        });
    }
  };

  const handleDeleteConfirm = () => {
    if (userIdToDelete !== null) {
      UserService.deleteUser(userIdToDelete)
        .then(() => {
          setUsers((prevUsers) => prevUsers.filter((user) => user.Id !== userIdToDelete));
          setOpenDeleteDialog(false);
          setOpenMessage({ isOpen: true, type: 'success', message: 'Usuário excluído!' });
          setUserIdToDelete(null);
        })
        .catch((error) => {
          console.error("There was an error deleting the user!", error);
          setOpenDeleteDialog(false);
          setOpenMessage({ isOpen: true, type: 'error', message: 'Erro ao excluir usuário!' });
          setUserIdToDelete(null);
        });
    }
  };

  const handleDeleteCancel = () => {
    setOpenDeleteDialog(false);
    setUserIdToDelete(null);
  };

  const handleEditCancel = () => {
    setOpenEditDialog(false);
    setEditUser({ Id: '', Name: '', Email: '', Main: false, SupplierId: '', RoleId: '' });
  };

  const handleAddUserClick = (user) => {
    //setAddUser({ Email: user.Email, Name: user.Name, Main: user.Main, SupplierId: 1, RoleId: user.RoleId });
    setOpenAddDialog(true);
  };

  const handleAddUserConfirm = () => {
    UserService.postUser(addUser)
      .then(() => {
        setOpenAddDialog(false);
        setAddUser({ Name: '', Email: '', Main: false, SupplierId: 1, RoleId: '' });
        setOpenMessage({ isOpen: true, type: 'success', message: 'Usuário cadastrado!' });
        setRefresh(prev => !prev);
      })
      .catch((error) => {
        setOpenAddDialog(false);
        setOpenMessage({ isOpen: true, type: 'error', message: 'Erro ao cadastrar usuário!' });
        console.error("There was an error adding the user!", error);
      });
  };

  const handleAddUserCancel = () => {
    setOpenAddDialog(false);
  };

  const snackBar = (
    <Snackbar open={openMessage.isOpen} autoHideDuration={4000} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
      <MuiAlert onClose={handleClose} severity={openMessage.type} sx={{ width: "100%" }}>
        {openMessage.message}
      </MuiAlert>
    </Snackbar>
  )

  const permissoesOptions = [
    { value: 1, label: "ADMIN" },
    { value: 2, label: "USUARIO" },
  ];

  const rows = users.map((user) => ({
    Name: (
      <MDTypography display="block" variant="h6" color="text" fontWeight="bold">
        {user.Name}
      </MDTypography>
    ),
    Email: (
      <MDTypography display="block" variant="caption" color="text" fontWeight="medium">
        {user.Email}
      </MDTypography>
    ),
    Description: (
      <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
        {user.Role.Description}
      </MDTypography>
    ),
    action: (
      <MDBox display="flex" gap={2}>
        <MDButton
          size="medium"
          variant="contained"
          color="warning"
          onClick={() => handleEditClick(user)}
        >
          Editar
        </MDButton>
        <MDButton
          size="medium"
          variant="contained"
          color="error"
          onClick={() => handleDeleteClick(user.Id)}
        >
          Excluir
        </MDButton>
      </MDBox>
    ),
  }));

  return (
    <>
      <MDBox display="flex" justifyContent="flex-end" mb={2} pr={2}>
        <MDButton variant="contained" color="success" size="medium" onClick={handleAddUserClick}>
          Adicionar
        </MDButton>
      </MDBox>
      <Dialog
        open={openAddDialog}
        onClose={handleAddUserCancel}
        aria-labelledby="edit-dialog-title"
        aria-describedby="edit-dialog-description"
      >
        <DialogTitle id="edit-dialog-title">{"Criar usuário"}</DialogTitle>
        <DialogContent>
          <Autocomplete
            disablePortal
            options={permissoesOptions}
            sx={{ width: 300 }}
            value={permissoesOptions.find((option) => option.value === addUser.RoleId) || null}
            onChange={(event, newValue) =>
              setAddUser({ ...addUser, RoleId: newValue ? newValue.value : null })
            }
            isOptionEqualToValue={(option, value) => option.value === value.value}
            renderInput={(params) => <TextField {...params} label="Permissões" />}
          />
          <TextField
            autoFocus
            margin="dense"
            label="Nome"
            fullWidth
            variant="outlined"
            value={addUser.name}
            onChange={(e) => setAddUser({ ...addUser, Name: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Email"
            fullWidth
            variant="outlined"
            value={addUser.email}
            onChange={(e) => setAddUser({ ...addUser, Email: e.target.value })}
            required={true}
          />
          <FormControlLabel
            control={
              <Switch
                checked={addUser.isPrimary}
                onChange={(e) => setAddUser({ ...addUser, Main: e.target.checked })}
              />
            }
            label="Principal?"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAddUserCancel} color="primary">
            Cancelar
          </Button>
          <Button onClick={handleAddUserConfirm} color="primary">
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openDeleteDialog}
        onClose={handleDeleteCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirmar exclusão"}</DialogTitle>
        <DialogContent>
          <MDTypography>{"Você tem certeza que deseja excluir este usuário?"}</MDTypography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel} color="primary">
            Cancelar
          </Button>
          <Button onClick={handleDeleteConfirm} color="primary">
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openEditDialog}
        onClose={handleEditCancel}
        aria-labelledby="edit-dialog-title"
        aria-describedby="edit-dialog-description"
      >
        <DialogTitle id="edit-dialog-title">{"Editar usuário"}</DialogTitle>
        <DialogContent>
          <Autocomplete
            disablePortal
            options={permissoesOptions}
            sx={{ width: 300 }}
            value={permissoesOptions.find((option) => option.value === editUser.RoleId) || null}
            onChange={(event, newValue) =>
              setEditUser({ ...editUser, RoleId: newValue ? newValue.value : null })
            }
            isOptionEqualToValue={(option, value) => option.value === value.value}
            renderInput={(params) => <TextField {...params} label="Permissões" />}
          />
          <TextField
            autoFocus
            margin="dense"
            label="Nome"
            fullWidth
            variant="outlined"
            value={editUser.Name}
            onChange={(e) => setEditUser({ ...editUser, Name: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Email"
            fullWidth
            variant="outlined"
            value={editUser.Email}
            disabled={true}
          />
          <FormControlLabel
            control={
              <Switch
                checked={editUser.Main}
                onChange={(e) => setEditUser({ ...editUser, Main: e.target.checked })}
              />
            }
            label="Principal?"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditCancel} color="primary">
            Cancelar
          </Button>
          <Button onClick={handleEditConfirm} color="primary">
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>

      <DataTable
        table={{
          columns: [
            { Header: "usuário", accessor: "Name", width: "30%", align: "left" },
            { Header: "email", accessor: "Email", width: "30%", align: "left" },
            { Header: "permissões", accessor: "Description", width: "30%", align: "left" },
            { Header: "", accessor: "action", width: "45%", align: "left" },
          ],
          rows: rows,
        }}
        isSorted={true}
        entriesPerPage={true}
        showTotalEntries={true}
        noEndBorder
      />

      {snackBar}
    </>
  );
}
